import React, { useEffect, useRef, useState } from "react";

import { ReactComponent as Dashboard } from "../../../Assets/PaymentsAppSidebar/Dashboard.svg";
import { ReactComponent as Invoice } from "../../../Assets/PaymentsAppSidebar/Invoice.svg";
import { ReactComponent as Payout } from "../../../Assets/PaymentsAppSidebar/Payout.svg";
import { ReactComponent as Customers } from "../../../Assets/PaymentsAppSidebar/Customers.svg";
import { ReactComponent as Transactions } from "../../../Assets/PaymentsAppSidebar/Transactions.svg";
import { ReactComponent as Settings } from "../../../Assets/PaymentsAppSidebar/Settings.svg";
import SidebarItem from "./SidebarItem";
import SettingsSubMenu from "./SettingsSubMenu";
import { PaymentRoutes } from "../../../Contracts/Routes";
import { useOnboardingStore } from "../../../Store/Onboarding";
import { ReactComponent as Support } from "../../../Assets/PaymentsAppSidebar/Support.svg";
import { ReactComponent as Help } from "../../../Assets/PaymentsAppSidebar/Help.svg";
import { useUserStore } from "../../../Store/User";
const initializeFreshchat = (currentUser: any) => {
  if (!window.fcWidget) {
    console.error("Freshchat widget not loaded");
    return;
  }

  try {
    window.fcWidget.init({
      token: process.env.REACT_APP_FRESHCHAT_TOKEN || "",
      host: "https://wchat.freshchat.com",
      tags: ["product"],
      externalId: currentUser?.id,
      restoreId: currentUser?.fc_token,
      config: {
        cssNames: {
          widget: "custom_fc_frame",
          expanded: "custom_fc_expanded"
        },
        headerProperty: {
          left: "5px",
          hideChatButton: true,
          backgroundColor: "#0D47A1",
          direction: "ltr",
          position: "left"
        },
        content: {
          actions: {
            csat_yes: "No, rate agent",
            csat_no: "Continue chat"
          },
          headers: {
            csat_question: "Is there anything else we can assist you with?",
            csat_no_question: "Please help us with suggestions to improve"
          }
        }
      }
    });

    window.fcWidget.user.get(async (getUserResponse: any) => {
      const getUserStatus = getUserResponse && getUserResponse.status;
      if (getUserStatus !== 200 && !!currentUser) {
        const { first_name, last_name, email, phone } = currentUser;

        window.fcWidget.user.setProperties({
          firstName: first_name || "",
          lastName: last_name || "",
          email,
          phone
        });
      }
    });
  } catch (error) {
    console.error("Error initializing Freshchat:", error);
  }
};

const PaymentsAppSidebar = () => {
  const refOfSettingsSubMenu = useRef<HTMLDivElement>(null);
  const refOfSettingsButton = useRef<HTMLDivElement>(null);
  const { currentUser } = useUserStore();
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://wchat.freshchat.com/js/widget.js";
    script.async = true;
    script.id = "freshchat-widget-js";
    script.onload = () => initializeFreshchat(currentUser);
    document.head.appendChild(script);

    const handleClickOutside = (event: MouseEvent) => {
      if (
        refOfSettingsSubMenu.current &&
        !refOfSettingsSubMenu.current.contains(event.target as Node) &&
        refOfSettingsButton.current &&
        !refOfSettingsButton.current.contains(event.target as Node)
      ) {
        setSettingSubMenuVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [currentUser]);
  const [settingSubMenuVisible, setSettingSubMenuVisible] = useState(false);
  const { isOnboardingComplete } = useOnboardingStore();
  const mainAppActive = isOnboardingComplete();
  return (
    <div className="flex">
      <nav className="flex flex-col inset-y-0 bg-gray-950 shadow-lg">
        <ul className="relative flex flex-col items-center justify-between w-16 ml-1 h-full">
          <div>
            {!mainAppActive && (
              <SidebarItem
                href={PaymentRoutes.GETTING_STARTED}
                LogoComponent={Dashboard}
                title="Getting started"
              />
            )}
            {mainAppActive && (
              <SidebarItem
                href={PaymentRoutes.CUSTOMERS}
                LogoComponent={Customers}
                title="Customers"
              />
            )}
            <SidebarItem
              href={PaymentRoutes.TRANSACTIONS}
              LogoComponent={Transactions}
              title="Transactions"
            />
            {mainAppActive && (
              <SidebarItem href={PaymentRoutes.INVOICES} LogoComponent={Invoice} title="Invoices" />
            )}
            <SidebarItem href={PaymentRoutes.PAYOUTS} LogoComponent={Payout} title="Payouts" />
            <div ref={refOfSettingsButton}>
              <SidebarItem
                LogoComponent={Settings}
                title="Settings"
                onClick={() => setSettingSubMenuVisible(!settingSubMenuVisible)}
                includePaths={[
                  PaymentRoutes.SETTINGS_CONFIG,
                  PaymentRoutes.SETTINGS_USERS,
                  PaymentRoutes.SETTINGS_INTEGRATION,
                  PaymentRoutes.QUICKBOOKS_SETTINGS,
                  PaymentRoutes.XERO_SETTINGS,
                  PaymentRoutes.ADMIN_TEAMS
                ]}
              />
            </div>
          </div>

          <div>
            <div
              className="flex items-center justify-center"
              onClick={() => {
                if (window.fcWidget) {
                  window.fcWidget.open();
                } else {
                  console.error("Freshchat widget not initialized");
                }
              }}
            >
              <SidebarItem LogoComponent={Support} title="Support" external />
            </div>
            <hr className="border-gray-700 my-2" />
            <SidebarItem
              href={"https://help.zomentum.com/support/solutions/44000817671"}
              LogoComponent={Help}
              title="Help"
              external
            />
          </div>
        </ul>
      </nav>

      {settingSubMenuVisible && (
        <div className="relative" ref={refOfSettingsSubMenu}>
          <SettingsSubMenu />
        </div>
      )}
    </div>
  );
};

export default PaymentsAppSidebar;
